import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { getNewStoreData, getView } from './services/util';
import { Box, Typography } from '@mui/material';
import { ServiceConfigProvider } from './context/ServiceConfigContext';
import { StoreViewRoutes } from './StoreView';
import { CUSTOMER_OWNED_VIEW, CUSTOMER_VIEW, SPECIAL_ORDER_VIEW, STORE_VIEW } from './services/const';
import { CustomerOwnedViewRoutes } from './CustomerOwnedView';
import { SpecialOrderViewRoutes } from './SpecialOrderView';
import { ServiceRequestNotAvailableViewRoutes } from './ServiceRequestNotAvailableView';
// import { CustomerViewRoutes } from './CustomerView';

const App: React.FC = () => {
  const {
    accessToken,
    storeId,
    externalIdentity,
    cartId,
    productId,
    associateId,
    associateEmail,
    profileId,
    extendedAttributes,
    associateFullName,
  } = getNewStoreData();

  if (!accessToken || !storeId || !externalIdentity || !cartId) {
    return (
      <Box p={4}>
        <Typography color="error" variant="body1">
          Missing authentication or store context.
        </Typography>
      </Box>
    );
  }

  const showView = getView(productId, profileId);

  const resolvedAssociateId = associateId ?? null;
  const resolvedAssociateEmail = associateEmail ?? null;
  const resolvedAssociateName = associateFullName ?? null;

  return (
    <ServiceConfigProvider
      productId={productId!}
      storeId={storeId || ''}
      extendedAttributes={extendedAttributes}
      associateId={resolvedAssociateId}
      associateEmail={resolvedAssociateEmail}
      associateName={resolvedAssociateName}
    >
      <Router>
        {showView === STORE_VIEW ? (
          <StoreViewRoutes
            storeId={storeId}
            externalIdentity={externalIdentity}
            associateId={resolvedAssociateId!}
            associateEmail={resolvedAssociateEmail!}
            associateName={resolvedAssociateName ?? resolvedAssociateEmail ?? resolvedAssociateId ?? ''}
          />
        ) : showView === CUSTOMER_OWNED_VIEW ? (
          <CustomerOwnedViewRoutes
            storeId={storeId}
            externalIdentity={externalIdentity}
            cartId={cartId}
            productId={productId!}
          />
        ) : showView === SPECIAL_ORDER_VIEW ? (
          <SpecialOrderViewRoutes
            storeId={storeId}
            externalIdentity={externalIdentity}
            cartId={cartId}
            productId={productId!}
          />
        ) : showView === CUSTOMER_VIEW ? (
          <StoreViewRoutes
            storeId={storeId}
            externalIdentity={externalIdentity}
            associateId={resolvedAssociateId!}
            associateEmail={resolvedAssociateEmail!}
            associateName={resolvedAssociateName ?? resolvedAssociateEmail ?? resolvedAssociateId ?? ''}
            profileId={profileId!}
          />
          // <CustomerViewRoutes
          //   storeId={storeId}
          //   externalIdentity={externalIdentity}
          //   profileId={profileId!}
          // />
        ) : (
          <ServiceRequestNotAvailableViewRoutes />
        )}
      </Router>
    </ServiceConfigProvider>
  );

};

export default App;
